<template>
    <rkm-modal
        :buttons="['cancel']"
        ref="Modal"
        :title="`Detalhamento de cotas - ${nomeFantasia}`"
        large
    >
        <rkm-area
            title="Cotas Financeiras (R$)"
            type="fieldset"
            v-if="cotasFinanceiras.length"
        >
        <rkm-table
                :items="cotasFinanceiras"
                :fields="fieldsFinanceiro"
            >
                <template v-slot:cell(cotaValor)="{ item }">
                    R$ {{ formatarValor(item.cotaValor) }}
                </template>
                <template v-slot:cell(cotaAppValor)="{ item }">
                    R$ {{ calcularCotaValor(item.cotaValor, item.percentualFinanceiro) }}
                </template>
            </rkm-table>
        </rkm-area>

        <rkm-area
            title="Cotas Físicas (exames)"
            type="fieldset"
            v-if="cotasQuantitativas.length"
        >
            <rkm-table
                :items="cotasQuantitativas"
                :fields="fieldsQuantitativo"
            >
                <template v-slot:cell(cotaQuantidade)="{ item }">
                    {{ item.cotaQuantidade }} exames
                </template>
                <template v-slot:cell(cotaAppQuantidade)="{ item }">
                    {{ calcularCotaQuantidade(item.cotaQuantidade, item.percentualQuantitativo) }} exames
                </template>
            </rkm-table>
        </rkm-area>

        <p v-if="!cotasFinanceiras.length && !cotasQuantitativas.length" class="text-muted text-center">
            Nenhuma cota configurada para este laboratório.
        </p>
    </rkm-modal>
</template>

<script>
import { formats } from '@/mixins'

export default {
    mixins: [formats],

    data: () => ({
        nomeFantasia: '',
        periodos: [],
    }),

    computed: {
        cotasFinanceiras() {
            return this.periodos.filter(p => p.cotaTipoId === 1)
        },

        cotasQuantitativas() {
            return this.periodos.filter(p => p.cotaTipoId === 2)
        },

        fieldsFinanceiro() {
            return [
                { key: 'inicio', label: 'Início', class: 'text-center' },
                { key: 'fim', label: 'Fim', class: 'text-center' },
                { key: 'cotaValor', label: 'Cota total', class: 'text-center' },
                { key: 'percentualFinanceiro', label: '% APP', class: 'text-center' },
                { key: 'cotaAppValor', label: 'Cota disponível ao APP', class: 'text-center' },
            ]
        },

        fieldsQuantitativo() {
            return [
                { key: 'inicio', label: 'Início', class: 'text-center' },
                { key: 'fim', label: 'Fim', class: 'text-center' },
                { key: 'cotaQuantidade', label: 'Cota total', class: 'text-center' },
                { key: 'percentualQuantitativo', label: '% APP', class: 'text-center' },
                { key: 'cotaAppQuantidade', label: 'Cota disponível ao APP', class: 'text-center' },
            ]
        },
    },

    methods: {
        open(item) {
            this.nomeFantasia = item.nomeFantasia || ''
            this.periodos = item.periodos || []
            this.$refs.Modal.show()
        },

        formatarValor(valor) {
            const v = parseFloat(valor) || 0
            return v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },

        calcularCotaValor(valor, percentual) {
            const resultado = Math.floor((parseFloat(valor) || 0) * (Number(percentual) || 0) / 100 * 100) / 100
            return resultado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },

        calcularCotaQuantidade(quantidade, percentual) {
            return Math.floor((parseInt(quantidade) || 0) * (Number(percentual) || 0) / 100)
        },
    },
}
</script>
